import * as React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import AdminDashboardPage from 'pages/admin/AdminDashboard';
import AssessmentPage from 'pages/shared/Survey';
import AssessmentResultsPage from 'pages/shared/AssessmentResult/assessmentResults';
import FacilityUserSettingsPage from 'pages/shared/FacilityUserSettings';
import PatientAccountsPage from 'pages/shared/PatientAccounts';
import PatientDetailsPage from 'pages/shared/PatientDetails';
import PatientRegistrationPage from 'pages/shared/PatientRegistration';
import PatientAccountSetupPage from 'pages/shared/PatientAccountSetup';
import FacilityUserAccountsPage from 'pages/shared/FacilityUserAccounts';
import FacilityUserRegistrationPage from 'pages/shared/FacilityUserRegistration';
import FacilityUserEditPage from 'pages/shared/FacilityUserEdit';
import ReportsPage from 'pages/admin/AdminReports';
import PatientResourcesPage from 'pages/patient/PatientResources';
import HelpPage from 'pages/shared/Help';
import Page404 from 'pages/errors/404';
import CoreMeasuresWorklistPage from 'pages/shared/CoreMeasuresWorklist';
import CoreMeasuresFacilityInfoPage from 'pages/shared/CoreMeasuresFacilityInfo';
import CoreMeasuresFacilityInfoPopulationEntryPage from 'pages/shared/CoreMeasuresFacilityInfoPopulationEntry';

import { AdminRoutes, AllRoutes } from 'constants/routes';
import { PDFFileDownload } from 'pages/shared/PrintableAssessments/download';
import { HelpFileDownload } from 'pages/shared/Help/download';
import { AttachmentDownload } from 'pages/shared/Attachments/download';
import PixDataEntryPage from 'pages/shared/PixDataEntry';
import FacilityLibraryPage from '../../shared/FacilityLibrary';
import PatientEditPage from '../../shared/PatientEdit';

const AdminRouting = (): React.JSX.Element => (
  <Router>
    <Switch>
      <Redirect exact path={AllRoutes.LOGIN} to={AdminRoutes.DASHBOARD} />
      <Route exact path={AdminRoutes.DASHBOARD} component={AdminDashboardPage} />
      <Route exact path={AdminRoutes.PATIENT_ACCOUNTS} component={PatientAccountsPage} />
      <Route exact path={`${AdminRoutes.PATIENT_REGISTRATION}/:facilityID`} component={PatientRegistrationPage} />
      <Route exact path={`${AdminRoutes.PATIENT_ACCOUNTS}/:patient`} component={PatientDetailsPage} />
      <Route exact path={`${AdminRoutes.PATIENT_ACCOUNTS}/:patient/account-setup`} component={PatientAccountSetupPage} />
      <Route exact path={`${AdminRoutes.PATIENT_ACCOUNTS}/:patientId/edit`} component={PatientEditPage} />
      <Route exact path={AdminRoutes.FACILITY_USER_ACCOUNTS} component={FacilityUserAccountsPage} />
      <Route path={AdminRoutes.FACILITY_USER_REGISTRATION} component={FacilityUserRegistrationPage} />
      <Route path={`${AdminRoutes.FACILITY_USER_EDIT}/:accountID`} component={FacilityUserEditPage} />
      <Route path={AdminRoutes.ADMIN_REPORTS} component={ReportsPage} />
      <Redirect exact path={AllRoutes.REPORTS} to={AdminRoutes.ADMIN_REPORTS} />
      <Route path={AdminRoutes.ACCOUNT} component={FacilityUserSettingsPage} />
      <Route path={AdminRoutes.RESOURCES} component={PatientResourcesPage} />
      <Route path={`${AllRoutes.HELP_DOWNLOAD}/:filename`} component={HelpFileDownload} />
      <Route path={AdminRoutes.HELP} component={HelpPage} />
      <Route path={`${AllRoutes.DOWNLOAD}/:filename`} component={PDFFileDownload} />
      <Route path={`${AllRoutes.ATTACHMENT_DOWNLOAD}/:attachmentId`} component={AttachmentDownload} />
      <Route path={`${AdminRoutes.ASSESSMENT}/:assessmentNumber/:instrumentTypeID/:appliedWhenID/:patientID`} component={AssessmentPage} />
      <Route path={`${AdminRoutes.ASSESSMENT_RESULTS}/:careID/:instrumentTypeID/:patientID`} component={AssessmentResultsPage} />
      <Route path={`${AdminRoutes.CORE_MEASURES_WORKLIST}`} component={CoreMeasuresWorklistPage} />
      <Route path={`${AdminRoutes.CORE_MEASURES_FACILITY_INFO}`} component={CoreMeasuresFacilityInfoPage} />
      <Route path={`${AdminRoutes.CORE_MEASURES_FACILITY_INFO_POPULATION_ENTRY}`} component={CoreMeasuresFacilityInfoPopulationEntryPage} />
      <Route path={`${AdminRoutes.FACILITY_LIBRARY}`} component={FacilityLibraryPage} />
      <Route path={`${AllRoutes.PIX_DATA_ENTRY}`} component={PixDataEntryPage} />
      <Route component={Page404} />
    </Switch>
  </Router>
);

export default AdminRouting;
